function e(e){return e==null}export{e as isNullish};
//# sourceMappingURL=isNullish-Mu0-VITK.js.map